import React, { Component } from 'react';
import {loadScript} from '../../../utilities/loadScript';
import './index.css';
class Footer extends Component {

	componentWillMount() {
		loadScript('ionicons','https://unpkg.com/ionicons@4.5.0/dist/ionicons.js');
	}

	render() {
		const nofollow = this.props.location && this.props.location === '/' ? '' : ' nofollow';
		const year = Math.floor( Date.now() / (1000 * 60 * 60 * 24 * 365 ) + 1970);
		const location = this.props.location ? this.props.location.replace(/\//g, "") : '' ;
		return (
			<footer className={"footer " + location}>
				<div className="footer__details hide">
					<div className="footer__left">
						<a href="https://www.instagram.com/_mirrad" target="_blank" rel="noopener noreferrer"><ion-icon size="large" name="logo-instagram"></ion-icon></a>
						<a href="https://en-gb.facebook.com/MIRRADinfo" target="_blank" rel="noopener noreferrer"><ion-icon size="large" name="logo-facebook"></ion-icon></a>
						<span>&copy; {year} MIRRAD</span>
					</div>
					<div className="footer__right">Site by <a rel={"noopener noreferrer" + nofollow} href="https://loopmill.com" target="_blank">Loopmill</a></div>
				</div>		

			</footer>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/layout/Footer/index.js